// Environment configuration for API endpoints
const config = {
  development: {
    API_BASE_URL: 'http://localhost:5000'
  },
  production: {
    API_BASE_URL: process.env.REACT_APP_API_URL || 'https://trivia-backend-sqdgx2xgtq-as.a.run.app'
  }
};

export default config[process.env.NODE_ENV || 'development'];
